import * as yup from 'yup';

export const editConversationSchema = yup.object().shape({
  orderId: yup.string().required(),
});
